/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
/* tslint:disable: no-duplicate-imports this is a change */
import { IModuleProps, INodeProps } from '@msdyn365-commerce-modules/utilities';
import * as Msdyn365 from '@msdyn365-commerce/core';
import { AttributeValue } from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
import classnames from 'classnames';
import { reaction } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { getAttributesForSelectedVariant } from '@msdyn365-commerce-modules/product-specification';
import { AttributesForSelectedVariantInput } from '@msdyn365-commerce-modules/product-specification';


//import { ProductSpecificationTableRow } from './components/obrien-upc-table-stucture';
import { IObrienUpcData } from './obrien-upc.data';
import { IObrienUpcProps } from './obrien-upc.props.autogenerated';

export interface IProductSpecificationViewProps extends IObrienUpcProps<{}> {
    ProductSpecification: IModuleProps;
    ProductSpecificationTableProps: INodeProps;
    ProductSpecificationTableBodyProps: INodeProps;
    productSpecificationResult?: (JSX.Element | null)[];
    title?: React.ReactNode;
    onlinetitle?: React.ReactNode;
    buttontext: string;
    buttonlink: string;

}

/**
 *
 * ProductSpecification component
 * @extends {React.Component<IObrienUpcProps<IObrienUpcData>>}
 */
@observer
class ProductSpecification extends React.Component<IObrienUpcProps<IObrienUpcData>> {
    public async componentDidMount(): Promise<void> {
        const { context, data, telemetry } = this.props;

        // @ts-ignore: Compiler not reconizing condition check for function params
        reaction(
            () => (data.product.result ? data.product.result.RecordId : null),
            () => {
                if (context && data.product.result) {
                    //@ts-ignore
                    const actionInput = new AttributesForSelectedVariantInput(
                        data.product.result.RecordId,
                        // @ts-ignore
                        +context.actionContext.requestContext.apiSettings.channelId,
                        data.product.result
                    );
                        //@ts-ignore
                    getAttributesForSelectedVariant(actionInput, this.props.context.actionContext).catch(error => {
                        telemetry.warning(error);
                        telemetry.debug('Unable to update attributes for Product');
                        telemetry.error(error);
                    });
                }
            }
        );
    }

    // tslint:disable-next-line:max-func-body-length
    public render(): JSX.Element | null {
        let data: IObrienUpcData;

        try {
            data = this.props.data;
        } catch (e) {
            this.props.telemetry.error(`Something went wrong ------${e}`);
            return <div>{e}</div>;
        }

        if (!data.productSpecificationData.result || data.productSpecificationData.result.length <= 0) {
            this.props.telemetry.error('Product specification content is empty, module wont render.');
            return null;
        }

        const { heading, className, onlineheading, buttontext, buttonlink } = this.props.config;

        const ButtonText = buttontext ? buttontext : 'No Text';
        const ButtonLink = buttonlink ? buttonlink : 'No Link';

        
        const { productSpecificationData } = this.props.data;

        const viewProps = {
            ...this.props,
            buttontext: ButtonText,
            buttonlink: ButtonLink,

            ProductSpecification: {
                moduleProps: this.props,
                className: classnames('locally', className)
            },
            ProductSpecificationTableProps: {
                className: classnames('nick-test'),
                tag: 'span'
            },
            ProductSpecificationTableBodyProps: {
                className: '',
                tag: 'div'
            },
            title: heading && heading.text && (
                <Msdyn365.Text
                  className='ms-product-specification__heading'
                  tag={heading.tag || 'h2'}
                  text={heading.text}
                  editProps = {{onEdit: this.handleHeadingChange, requestContext: this.props.context.request}}
                />),
            onlinetitle: onlineheading && onlineheading.text && (
                <Msdyn365.Text
                    className='test'
                    tag={onlineheading.tag || 'h3'}
                    text={onlineheading.text}
                    editProps = {{onEdit: this.handleOnlineHeadingChange, requestContext: this.props.context.request}}
                />),
            
            productSpecificationResult: productSpecificationData && this._createTableBody(data)
        } as IProductSpecificationViewProps;

        return this.props.renderView(viewProps) as React.ReactElement;
    }
    public handleHeadingChange = (event: Msdyn365.ContentEditableEvent) => this.props.config.heading!.text = event.target.value;
    public handleOnlineHeadingChange = (event: Msdyn365.ContentEditableEvent) => this.props.config.onlineheading!.text = event.target.value;
    private _createTableBody(content: IObrienUpcData): (JSX.Element | null)[] {
        return content.productSpecificationData.result!.map((product, index) => {
            const cellData: JSX.Element | null = this._renderProductCell(product);

            if (!cellData) {
                return null;
            }

            if (product.Name === "UPC") {

                const scriptHtml = `<script id="lcly-script-0" async></script> 
                <script id="cly-config-0">
                var lcly_config_0 = {

                        "company_name": "O'Brien",
                        "button_text": "Find it Locally",
                        "button_id": "HTML",
                        "company_id": "8805",
                        "css": "4",
                        "color_1": "#0276b2",
                        "upc": ${product.TextValue},
                        "show_related_styles": "1",
                        "n_related_styles": "3",
                        "show_location_switcher": "1",
                        "lang": "en-us",
                        "show_dealers": "1",
                        "n_dealers": "3",
                        "radius_in_miles": "100"
                    
                  };
                  var lcly_query_0 = Object.keys(lcly_config_0)
                  .reduce(function(a,k){a.push(encodeURIComponent(k) + '=' 
                  + encodeURIComponent(lcly_config_0[k]));return a},[]).join('&');
                  var lcly_endpoint_0 = 'https://obrien.locally.com/stores/map.js?' + lcly_query_0;
                  document.getElementById('lcly-script-0').src = lcly_endpoint_0;
                </script>
                <div id="lcly-button-0">
                    <a id="lcly-link-0" href="https://brands.locally.com" target="_blank">
                        Product Locator by Locally New
                    </a>
                </div>
                `;



                return (
                    
                    <div className="fifty" dangerouslySetInnerHTML={{ __html: scriptHtml, }} />

                );
            }

            return (
                null
            );
        });
    }

    private _renderProductCell(product: AttributeValue): JSX.Element | null {
        switch (product.DataTypeValue) {
            case 0: // none
                // Return span here instead of null so the row still shows
                return <span />;
            case 1: // Currency
                return this._renderCurrencyCell(product);
            case 2: // DateTime
                return this._renderDateTimeCell(product);
            case 3: // Decimal
                return this._renderDecimalCell(product);
            case 4: // Integer
                return this._renderIntegerCell(product);
            case 5: // Text
                return this._renderTextCell(product);
            case 6: // TrueFalse
                return this._renderTrueFalseCell(product);
            case 40: // Video
                this.props.telemetry.warning('Got video specification type, not supported yet so skipping line');
                return null;
            case 41: // Image
                this.props.telemetry.warning('Got image specification type, not supported yet so skipping line');
                return null;
            default:
                this.props.telemetry.warning(`Got unknown specification type ${product.DataTypeValue} so skipping line`);
                return null;
        }
    }

    private _renderCurrencyCell(product: AttributeValue): JSX.Element | null {
        if (product.CurrencyValue !== null && product.CurrencyValue !== undefined) {
            return (
                <span>
                    {product.CurrencyCode}
                    {product.CurrencyValue}
                </span>
            );
        }

        return null;
    }

    private _renderDateTimeCell(product: AttributeValue): JSX.Element | null {
        if (product.DateTimeOffsetValue !== null && product.DateTimeOffsetValue !== undefined && product.DateTimeOffsetValue.toUTCString) {
            return <span>{product.DateTimeOffsetValue.toUTCString()}</span>;
        }

        return null;
    }

    private _renderIntegerCell(product: AttributeValue): JSX.Element | null {
        if (product.IntegerValue !== null && product.IntegerValue !== undefined) {
            return <span>{product.IntegerValue}</span>;
        }

        return null;
    }

    private _renderDecimalCell(product: AttributeValue): JSX.Element | null {
        if (product.FloatValue !== null && product.FloatValue !== undefined) {
            return <span>{product.FloatValue}</span>;
        }

        return null;
    }

    private _renderTextCell(product: AttributeValue): JSX.Element | null {
        if (product.TextValue !== null && product.TextValue !== undefined) {
            // tslint:disable-next-line
            return <span dangerouslySetInnerHTML={Msdyn365.getRichTextHtml(product.TextValue)}/>;
        }

        return null;
    }

    private _renderTrueFalseCell(product: AttributeValue): JSX.Element | null {
        // TODO 20369885 setting to default value is needed to work around a platform bug where
        // config string value does not get its default value.
        if (product.BooleanValue) {
            return <span>{this.props.resources.trueValueText ? this.props.resources.trueValueText : 'Yes'}</span>;
        } else {
            return <span>{this.props.resources.falseValueText ? this.props.resources.falseValueText : 'No'}</span>;
        }
    }
}

export default ProductSpecification;
